import { ReactNode } from 'react';
import { Text } from '../../components/Text';

export const CheckinEditorSummary: React.FC<{ children: ReactNode }> = ({ children }) => {
    return (
        <div style={{margin: '10px 10px 0px'}}>
            <Text type="detail">
                {children}
            </Text>
        </div>
    );
};
